import { render, staticRenderFns } from "./SaveModal.vue?vue&type=template&id=0c79185a"
import script from "./SaveModal.vue?vue&type=script&lang=js"
export * from "./SaveModal.vue?vue&type=script&lang=js"
import style0 from "./SaveModal.vue?vue&type=style&index=0&id=0c79185a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports